import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Offcanvas } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

import InstructorSidebar  from './components/InstructorSidebar';
import InstructorTopbar   from './components/InstructorTopbar';
import InstructorFooter   from './components/InstructorFooter';
import ProfilePage        from '../common/pages/ProfilePage';
import ChangePasswordPage from '../common/pages/ChangePasswordPage';

// Reuse static info pages from org panel (same API, same design)
import OrgTermsPage    from '../organization/pages/OrgTermsPage';
import OrgPrivacyPage  from '../organization/pages/OrgPrivacyPage';
import OrgFaqPage      from '../organization/pages/OrgFaqPage';

import InstructorDashboard          from './pages/Dashboard';
import InstructorCourseList         from './pages/CourseList';
import InstructorManageUsers        from './pages/ManageUsers';
import InstructorForumList          from './pages/Forums/InstructorForumList';
import InstructorForumDetail        from './pages/Forums/InstructorForumDetail';
import InstructorVltList            from './pages/Vlt/InstructorVltList';
import InstructorEventCalendarPage from './pages/Calendar/InstructorEventCalendarPage';
import InstructorSurveyList         from './pages/Surveys/InstructorSurveyList';
import InstructorSurveyQuestions    from './pages/Surveys/InstructorSurveyQuestions';
import InstructorSurveyResponses    from './pages/Surveys/InstructorSurveyResponses';
import InstructorAssessmentList     from './pages/Assessments/InstructorAssessmentList';
import InstructorAssessmentAnalytics from './pages/Assessments/InstructorAssessmentAnalytics';
import InstructorSupportTicketsPage from './pages/SupportTickets/InstructorSupportTicketsPage';
import InstructorReports            from './pages/Reports/InstructorReports';
import InstructorLeaderboardPage    from './pages/Gamification/LeaderboardPage';

const InstructorLayout = () => {
  const [sidebarShow, setSidebarShow] = useState(false);
  const isMdUp = useMediaQuery({ minWidth: 768 });

  const handleTabChange = () => setSidebarShow(false);

  return (
    <div className="container-fluid vh-100 d-flex flex-row p-0 flex flex-col md:flex-row overflow-hidden">

      {/* Sidebar — desktop */}
      {isMdUp && (
        <div className="fixed top-0 left-0 h-full overflow-y-auto transition-transform transform -translate-x-full md:translate-x-0 md:static md:flex-shrink-0 w-full md:w-[260px] brand-app-sidebar z-50 md:z-auto">
          <InstructorSidebar onTabChange={handleTabChange} />
        </div>
      )}

      {/* Sidebar — mobile offcanvas */}
      {!isMdUp && (
        <Offcanvas show={sidebarShow} onHide={() => setSidebarShow(false)} style={{ backgroundColor: '#ffffff', width: '260px' }}>
          <Offcanvas.Header closeButton style={{ borderBottomColor: '#dee2e6', backgroundColor: '#ffffff' }}>
            <Offcanvas.Title style={{ color: '#495057' }}>Instructor Panel</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-0">
            <InstructorSidebar onTabChange={handleTabChange} />
          </Offcanvas.Body>
        </Offcanvas>
      )}

      {/* Main Content */}
      <div className="flex-grow-1 d-flex flex-column min-vh-100 flex flex-col flex-1 overflow-y-auto bg-white/90">
        <div className="border-bottom sticky top-0 z-40 items-center justify-between shadow-md">
          <InstructorTopbar onMenuClick={() => setSidebarShow(true)} />
        </div>
        <div className="flex-grow-1 overflow-auto p-2 flex-1 overflow-y-auto sm:p-5 md:p-2 lg:p-2">
          <Routes>
            <Route path="/dashboard"             element={<InstructorDashboard />}          />
            <Route path="/courses"               element={<InstructorCourseList />}          />
            <Route path="/users"                 element={<InstructorManageUsers />}         />
            <Route path="/forums"                element={<InstructorForumList />}           />
            <Route path="/forums/:id"            element={<InstructorForumDetail />}        />
            <Route path="/vlt"                   element={<InstructorVltList />}            />
            <Route path="/calendar"              element={<InstructorEventCalendarPage />} />
            <Route path="/surveys"               element={<InstructorSurveyList />}         />
            <Route path="/surveys/:id/responses"  element={<InstructorSurveyResponses />}    />
            <Route path="/surveys/:id/questions" element={<InstructorSurveyQuestions />}    />
            <Route path="/assessments"           element={<InstructorAssessmentList />}     />
            <Route path="/assessments/:id/analytics" element={<InstructorAssessmentAnalytics />} />
            <Route path="/support-tickets"       element={<InstructorSupportTicketsPage />} />
            <Route path="/reports"               element={<InstructorReports />}            />
            <Route path="/leaderboard"           element={<InstructorLeaderboardPage />}  />
            <Route path="/profile"               element={<ProfilePage />}                  />
            <Route path="/change-password"       element={<ChangePasswordPage />}           />
            <Route path="/terms"                 element={<OrgTermsPage />}                 />
            <Route path="/privacy"               element={<OrgPrivacyPage />}               />
            <Route path="/faqs"                  element={<OrgFaqPage />}                   />
            <Route path="/"                      element={<InstructorDashboard />}          />
          </Routes>
        </div>
        <InstructorFooter />
      </div>
    </div>
  );
};

export default InstructorLayout;
